/**
 * @file Utility to parse a string to a decimal value.
 * @copyright Copyright (c) 2018-present, Graham Fairweather
 * @module parseInteger
 */

export {default} from './.internal/_parseInt';
